export const toInt = value => (value && parseInt(value, 10)) || null;
export const toFloat = value => (value && parseFloat(value)) || null;